import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles, Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles = makeStyles(theme => ({
  fileChip: {
    fontWeight: theme.typography.fontWeightBold,
    margin: theme.spacing(0.5),
  },
  fileWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    flexBasis: '35%',
  },
  multiChips: {},
  selectedFile: {
    backgroundColor: theme.palette.facet.accentBlue,
    '&:hover': {
      backgroundColor: theme.palette.facet.accentBlue,
    },
  },
}));

export default function FileChips({
  fileCollection,
  handleDeleteFile,
  handleFileClick,
  fileExpand,
  setFileExpand,
  selectedFileId,
  setSelectedFileId,
  setAlternativeToggleDisplay,
}) {
  const classes = useStyles();

  const fileCount = fileCollection
    ? fileCollection.resources().list().length
    : 0;

  if (fileCount === 0) {
    return null;
  }

  if (fileCount === 1) {
    return fileCollection
      .resources()
      .list()
      .map(r => (
        <Chip
          className={classNames({
            [classes.selectedFile]: selectedFileId === r.id(),
          })}
          component={Typography}
          noWrap
          key={`file.${r.id()}`}
          label={r.attr('name')}
          color="primary"
          onDelete={() => handleDeleteFile(r)}
          onClick={() => handleFileClick(r)}
          size="small"
        />
      ));
  }
  return (
    <Box className={classes.fileWrapper}>
      {fileExpand ? (
        <>
          <Chip
            className={classNames(classes.fileChip, {
              [classes.multiChips]: true,
            })}
            label="Close files"
            onClick={() => {
              setAlternativeToggleDisplay(false);
              setSelectedFileId('');
              setFileExpand(!fileExpand);
            }}
            size="small"
          />
          {fileCollection
            .resources()
            .list()
            .map(r => (
              <Chip
                className={classNames({
                  [classes.fileChip]: selectedFileId !== r.id(),
                  [classes.multiChips]: true,
                  [classes.selectedFile]: selectedFileId === r.id(),
                })}
                key={`file.${r.id()}`}
                label={r.attr('name')}
                component={Typography}
                noWrap
                color="primary"
                onDelete={() => handleDeleteFile(r)}
                onClick={() => handleFileClick(r)}
                size="small"
              />
            ))}
        </>
      ) : (
        <Chip
          className={classes.fileChip}
          label={(
            <>
              {`${fileCount} files`}
              <ArrowDropDownIcon />
            </>
          )}
          color="primary"
          onClick={() => setFileExpand(!fileExpand)}
          size="small"
        />
      )}
    </Box>
  );
}

FileChips.propTypes = {
  fileCollection: PropTypes.object.isRequired,
  handleDeleteFile: PropTypes.func.isRequired,
  handleFileClick: PropTypes.func.isRequired,
  fileExpand: PropTypes.bool.isRequired,
  setFileExpand: PropTypes.func.isRequired,
  setAlternativeToggleDisplay: PropTypes.func.isRequired,
  setSelectedFileId: PropTypes.func.isRequired,
  selectedFileId: PropTypes.string,
};

FileChips.defaultProps = {
  selectedFileId: '',
};
